const header = document.getElementById('header');
const navbarmain = document.getElementById('mainnav');
const parents = navbarmain.querySelectorAll('.dropdown-parent');

const burger = document.querySelector('header .menu-icon');
const close = document.querySelector('header .close-icon');

const metanav = document.getElementById('metanav');
const oldMetanavPos = metanav.parentElement;

const iconnav = document.getElementById('iconnav');
const oldIconnavPos = iconnav.parentElement;

const langnav = document.getElementById('langnav');
const oldLangnavPos = iconnav.parentElement;

const burgerNavTop = document.querySelector('.burger-nav-top');



// mobile nav
burger.addEventListener('click', () => openBurgerNav());
close.addEventListener('click', () => closeBurgerNav());



const openBurgerNav = (): void => {
    document.body.classList.add('menu-open');

    navbarmain.after(metanav);
    navbarmain.after(iconnav);
    burgerNavTop.insertAdjacentElement('afterbegin', langnav);
}

const closeBurgerNav = (): void => {
    document.body.classList.remove('menu-open');

    oldMetanavPos.insertAdjacentElement('afterbegin', metanav);
    oldIconnavPos.insertAdjacentElement('afterbegin', iconnav);
    oldLangnavPos.insertAdjacentElement('afterbegin', langnav);
}

parents.forEach(parent => {
    parent.addEventListener('click',event => {
        if (window.innerWidth < 1160) {
            event.preventDefault();

            if (parent.classList.contains('is-active')) {
                parent.classList.remove('is-active');
                parent.classList.remove('clicked');
            } else {
                parent.classList.toggle('clicked');
            }

        } else if (!parent.classList.contains('clicked') && parent.classList.contains('level-1')) {
            closeNav();

            event.preventDefault();
            parent.classList.add('clicked');
            document.body.classList.add('menu-open');
        }
    })
});

document.body.addEventListener('click', (e) => {
    if (document.body.classList.contains('menu-open') && !e.target.closest('header')) {
        closeNav();
    }
});

if (window.innerWidth < 768) {
    let lastScrollTop = 0;
    window.addEventListener('scroll', (e) => {
        let top = document.documentElement.scrollTop;
        if (top > lastScrollTop && !document.body.classList.contains('menu-open')) {
            header.classList.add('is-hidden');
        } else if (top < lastScrollTop) {
            header.classList.remove('is-hidden');
        }
        lastScrollTop = top <= 0 ? 0 : top;
    });
}

function closeNav() {
    parents.forEach(parent => {
        parent.classList.remove('clicked')
    });
    document.body.classList.remove('menu-open');
}

